import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { SidebarContent, SidebarMenu } from '@monksflow/monks-ui';

export interface FeatureSidebarNavProps {
  children: ReactNode;
}

// Stagger spec — designer-tuned from the Tessra NavigationDrawer base
// to make the entrance more perceivable (originals 0.035 / 0.15 were
// almost imperceptible). The DS SidebarMenu has its own one-shot
// stagger consumed by the main rail at login, so we re-introduce the
// entrance here to play on every FeatureSidebar mount.
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.15,
    },
  },
};

/** Navigation container for `FeatureSidebar`. */
export function FeatureSidebarNav({ children }: FeatureSidebarNavProps) {
  return (
    <SidebarContent className="gap-0 pt-9">
      <motion.div
        data-testid="feature-sidebar-nav-stagger"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <SidebarMenu>{children}</SidebarMenu>
      </motion.div>
    </SidebarContent>
  );
}
